import GAL01GalleryViewer from './GAL01-gallery-viewer/GAL01-gallery-viewer.vue';
import GAL01GalleryFullscreen from './GAL01-gallery-fullscreen/GAL01-gallery-fullscreen.vue';

export default {
	components: {
	 'gal01-gallery-viewer': GAL01GalleryViewer,
	 'gal01-gallery-fullscreen': GAL01GalleryFullscreen
	},
	props: {
		galleryName: {
			required: true,
			type: String
		}
	},
	data() {
		return {
			gallery: {
				title: '',
				data: '',
				images: []
			},
			isGalleryViewerOpen: false,
			isGalleryFullscreenOpen: false,
			activeSlideIndex: 0
		}
	},
	mounted() {
		this.getGalleryImages();
	},
	methods: {
		getGalleryImages() {
			if (window[this.galleryName]) {
				this.gallery = window[this.galleryName];
			}
		},
		setActiveSlideIndex(index) {
			this.activeSlideIndex = index;
		},
		toggleGalleryViewer() {
			if (!this.isGalleryViewerOpen) {
				this.setActiveSlideIndex(0);
				document.body.style.overflowY = 'hidden';
				this.isGalleryViewerOpen = true;
			} else {
				document.body.style.overflowY = '';
				this.isGalleryViewerOpen = false;
			}
			
		},
		toggleGalleryFullscreen() {
			if (!this.isGalleryFullscreenOpen) {
				this.isGalleryViewerOpen = false;
				this.isGalleryFullscreenOpen = true;

				if (document.documentElement.requestFullscreen) {
					document.documentElement.requestFullscreen();
				}
			} else {
				this.isGalleryViewerOpen = true;
				this.isGalleryFullscreenOpen = false;

				if (document.exitFullscreen) {
					document.exitFullscreen();
				}
			}
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/GAL01-gallery/GAL01-gallery.js